var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransporte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.17,
    height: 87.256,
    viewBox: "0 0 90.17 87.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2d3539;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transporte",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-1",
    d: "M23.568,76.1v4.5c-.064,4.1-2.6,6.663-6.582,6.663s-6.4-2.461-6.5-6.506c-.038-1.516,0-3.037,0-4.52-3.2-.729-3.2-.729-3.2-3.99V52.015H2.368A2.09,2.09,0,0,1,0,49.63q.038-7.573,0-15.147c0-1.648.822-2.342,2.385-2.347s3.134,0,4.9,0V9.941C7.3,3.664,10.979,0,17.269,0H72.906c6.29,0,9.979,3.66,10,9.912v22.2H87.43c2.181.025,2.736.555,2.741,2.69V49.414c0,1.931-.6,2.541-2.5,2.58-1.516.034-3.029,0-4.757,0V72.749c0,2.736-.2,2.965-3.2,3.363v4.443c-.08,4.193-2.5,6.7-6.51,6.7s-6.5-2.516-6.565-6.65c-.025-1.457,0-2.918,0-4.5ZM79.208,21.823h-68.2v26.5H28.6c-3.52-1.4-7.078-2.541-10.636-3.681-1.224-.39-2.266-1.008-1.792-2.495s1.694-1.338,2.906-.949c3.626,1.165,7.324,2.118,10.856,3.537a51.615,51.615,0,0,0,23.53,3.74c1.694-.136,3.389,0,5.083,0a1.2,1.2,0,0,0-.775-.631c-3.342-1.076-6.692-2.118-10.03-3.24-1.622-.538-2.241-1.8-1.457-2.9s1.826-.792,2.863-.457c6.688,2.156,13.321,4.5,20.09,6.375,3.134.847,6.527.809,9.95,1.186ZM10.971,72.2H79.208V52.155H10.971ZM79.285,17.934v-7.8c0-4.6-1.906-6.489-6.548-6.493H24.144c-2.757,0-5.506-.055-8.272.089a4.906,4.906,0,0,0-4.858,4.316c-.212,3.257-.055,6.536-.055,9.907ZM3.685,35.868v12.39H7.074V35.868Zm79.454,0v12.39h3.342V35.872ZM14.1,76.048c0,1.881-.068,3.575,0,5.265.08,1.571,1.114,2.215,2.6,2.287,1.838.089,3-.563,3.134-2.076.152-1.787.034-3.6.034-5.477Zm62.02.064h-5.8c0,1.83-.1,3.528.025,5.21s1.224,2.368,3.13,2.279c1.563-.072,2.584-.767,2.635-2.431s0-3.266,0-5.053Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-1",
    d: "M48.705,62H36.934a4.029,4.029,0,0,1-1.881-.263,1.989,1.989,0,0,1-1-1.444,2.406,2.406,0,0,1,.966-1.682,3.526,3.526,0,0,1,1.868-.288H61.3c1.1.106,1.978.538,2,1.783s-.847,1.749-1.944,1.817c-.991.064-1.987.034-2.965.034Z",
    transform: "translate(-19.627 -33.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-1",
    d: "M115.44,61.862c-2.385.051-3.418-.513-3.253-1.859.25-2.02,1.868-1.694,3.245-1.737.58,0,1.3-.174,1.694.1.686.424,1.533,1.144,1.631,1.826.064.479-.945,1.245-1.618,1.627C116.719,62.065,116.024,61.862,115.44,61.862Z",
    transform: "translate(-64.658 -33.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M42.238,144.954a5.746,5.746,0,1,1,5.722-5.65,5.617,5.617,0,0,1-5.722,5.65Zm.424-7.989h-.8a8.4,8.4,0,0,0-1.546,2.347c-.275,1.063.983,2.118,2.118,2.008,1.216-.136,2.08-.919,1.834-2.092-.152-.813-1.021-1.5-1.58-2.262Z",
    transform: "translate(-21.123 -76.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M155.126,145.147a5.6,5.6,0,0,1-5.536-5.655,5.647,5.647,0,1,1,5.536,5.655Zm-.263-3.3.809-.025c.534-.771,1.394-1.5,1.521-2.33.174-1.161-.72-1.932-1.936-2.025-1.131-.085-2.334,1.05-2.02,2.118a8.811,8.811,0,0,0,1.61,2.262Z",
    transform: "translate(-86.227 -77.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M75.934,23.719H56.4c-2.385,0-2.868-.487-2.889-2.889V16.077c0-1.584.695-2.4,2.334-2.4H96.151c1.614,0,2.368.737,2.338,2.364-.038,1.758,0,3.52,0,5.282s-.6,2.376-2.474,2.38H75.951ZM57.242,19.987H94.775V17.416H57.242Z",
    transform: "translate(-30.845 -7.886)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporte);
export default __webpack_public_path__ + "static/media/Transporte.29721f1afebe0a97c360e863172a6f3a.svg";
export { ForwardRef as ReactComponent };